"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downtimeReasonFromJSON = exports.DowntimeReason = void 0;
// DEPRECATED IN FAVOR OF INCIDENTS
var DowntimeReason;
(function (DowntimeReason) {
    DowntimeReason["NONE"] = "NONE";
    DowntimeReason["MAINTENANCE"] = "MAINTENANCE";
    DowntimeReason["COMMISSIONING"] = "COMMISSIONING";
    DowntimeReason["POWER_OUTAGE"] = "POWER_OUTAGE";
    DowntimeReason["OPS_ISSUE"] = "OPS_ISSUE";
    DowntimeReason["HARDWARE_ISSUE"] = "HARDWARE_ISSUE";
    DowntimeReason["SOFTWARE_ISSUE"] = "SOFTWARE_ISSUE";
    DowntimeReason["OTHER"] = "OTHER";
})(DowntimeReason = exports.DowntimeReason || (exports.DowntimeReason = {}));
function downtimeReasonFromJSON(value) {
    return Object.values(DowntimeReason).includes(value)
        ? value
        : DowntimeReason.NONE;
}
exports.downtimeReasonFromJSON = downtimeReasonFromJSON;
